import AutoDismissToolTip from "@/components/AutoDismissToolTip";
import { Form } from "antd";
import React from "react";
import Input from "./BaseInput";

const StockNo: React.FC = () => {
    return (
        <AutoDismissToolTip title="模糊搜索请加上*号，如：* A5" trigger="click">
            <Form.Item label={<span className="search-field-label">商品货位</span>} name="stockNo">
                <Input />
            </Form.Item>
        </AutoDismissToolTip>
    );
};

export default React.memo(StockNo);
